import React from 'react'
import classnames from 'classnames'
import { Dialog, Button, Text, Flex, Content, Pane } from '@leverege/ui-elements'
import SelectPermissions from './EditPermissions'

import S from './EditPermissionsDialog.css'

export default class SelectPermissionsDialog extends React.Component {

  constructor( props ) {
    super( props )
    this.state = { selected : { } }
  }

  static getDerivedStateFromProps( props, state ) {
    const { permissions } = props
    if ( permissions != state.permissions ) {
      const selected = { }
      permissions.forEach( ( p ) => { selected[p.id] = p } )
      return { permissions, selected }
    }
    return null
  }

  onChange = ( evt ) => { 
    this.setState( { selected : evt.value } )
  }

  onOkay = ( ) => {
    this.props.onSelect( this.state.selected )
  }

  render() {
    const { onClose, show, role, permissions = [] } = this.props
    const { selected } = this.state
    const footer = (
      <div className={S.footer}>
        <Button variant="primary" disabled={isSame( permissions, selected )} onClick={this.onOkay}>Okay</Button>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
      </div>
    )
    return (
      <Dialog show={show} closeOnDocumentClick={false} contentVariant="dialogContent" title="Edit Permissions" footer={footer} onClose={onClose}>
        <SelectPermissions role={role} permissions={permissions} onChange={this.onChange}/>
      </Dialog>
    )
  }
}

function isSame( arr, obj ) {
  const array = arr || []
  const keys = Object.keys( obj )
  if ( keys.length != array.length ) {
    return false
  }
  return !array.some( ( p ) => { obj[p.id] == null } )
}
